var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.19048L1.03098 6.36874V16.7253L4.72458 18.8578L4.20909 19.7506L0 17.3205V5.7735L10 0L14.2091 2.43012L13.6936 3.32298L10 1.19048ZM5.45909 20.4723L5.97458 19.5795L10 21.9035L18.969 16.7253V6.36874L14.9436 4.04467L15.4591 3.15181L20 5.7735V17.3205L10 23.094L5.45909 20.4723ZM16.9181 7.55182L9.99847 3.55676L3.07883 7.55182V15.5419L9.99847 19.537L16.9181 15.5419V7.55182ZM8.57693 6.80406H8.22462L7.98103 7.0586L6.98211 8.10247L8.17391 9.24296L8.92925 8.45363H10.8152L11.3926 9.01932V9.66381L9.41425 11.6433L9.17283 11.8848V12.2263V13.8921H10.8224V12.5678L12.8008 10.5884L13.0422 10.3468V10.0053V8.67272V8.32611L12.7946 8.08355L11.7291 7.03968L11.4886 6.80406H11.1519H8.57693ZM9.17773 14.7174H10.8273V16.1607H9.17773V14.7174Z",
    fill: "#7FFAE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.0f43a306e5a366f1483d249ef2329c7b.svg";
export { ForwardRef as ReactComponent };